const globalStrings = {
  gamesManagement: "Game Management",
  createGame: "Create a New Game",
  gameName: "Game Name",
  createdAt: "created on",
  account: "account",
  accounts: "accounts",
  player: "player",
  playerName: "Player First Name",
  players: "players",
  create: "Create",
  submit: "Submit",
  startHexploit: "Start the Hexploit",
  email: "Email",
  success: "Your characters have been created successfully!",
  delete: "Delete",
  addCharacter: "Add a character",
  characterName: "Character Name",
  joinGame: "Join the game",
  charactersCreation: "Create your characters",
  goodLuck: "Use your imagination!",
  accountTitle: "My account",
  accountEmailVerified: "Email verified",
  accountEmailValidationRequired: "Validation required",
  accountEmailNotValidated: "Your email has not been validated yet",
  accountSendValidationEmail: "Send validation email",
  accountGeneralInfo: "General information",
  accountEmailPlaceholder: "email@address.com",
  accountNewsletterLabel: "Subscribe to the newsletter",
  accountNewsletterEnableConfirmTitle: "Confirm subscription",
  accountNewsletterEnableConfirmBody: "By continuing, you agree to receive Hexploit news and informational emails.",
  accountNewsletterDisableConfirmTitle: "Confirm unsubscription",
  accountNewsletterDisableConfirmBody: "Are you sure you no longer want to receive updates?",
  accountNewsletterConfirmCancel: "Cancel",
  accountNewsletterConfirmConfirm: "Confirm",
  accountSaveChanges: "Save changes",
  accountSecurityTitle: "Security",
  accountNewPasswordLabel: "New password",
  accountNewPasswordPlaceholder: "New password...",
  accountPasswordConfirmationLabel: "Confirm new password",
  accountPasswordConfirmationPlaceholder: "Confirm your new password...",
  accountChangePassword: "Change my password",
  accountGamesTitle: "My games",
  accountGamesCount: "games",
  accountNoGames: "No games in progress at the moment.",
  accountViewGame: "View game",
  accountUpdateSuccess: "Information updated successfully",
  accountPasswordMismatch: "Password confirmation does not match",
  accountWelcomeEmailSubject: "Welcome to Hexploit",
  accountParticipantsLabel: "participants",
  accountCharactersLabel: "characters",
  accountDeletePrompt: "If you no longer wish to be registered with A2Z eSanté, you can ask us to",
  accountDeleteLinkText: "delete your account",
  accountDeleteSuffix: "and all of its data.",
  accountValidationEmailSentTitle: "Email sent",
  accountValidationEmailSentBody: "A validation email has been sent.",
  accountPasswordResetSentTitle: "Email sent",
  accountPasswordResetSentBody: "A password reset email has been sent.",
  accountNewsletterSavedTitle: "Preferences saved",
  accountNewsletterSavedBody: "Your newsletter preferences have been updated.",
  accountMetaTitle: "Hexploit - My account",
  gamesAdminDescription: "Create a new game and manage ongoing sessions.",
  gamesAdminBadge: "Admin",
  gamesInProgressTitle: "Created games",
  gamesCountLabel: "games",
  gamesFilterDateLabel: "Filter by date",
  gamesFilterDatePlaceholder: "Select a date",
  gameJoinBadge: "Join the game",
  gameHeaderLine1: (name: string) => `Hexploit game: ${name}`,
  gameHeaderLine2: (date: string, time: string) => `on ${date} at ${time}`,
  gameJoinQrHint: "Scan this QR code to join the game.",
  gameOpenLink: "Open link",
  gameShareLink: "Share link",
  gameShareTitle: "Join Hexploit",
  gameParticipantsTitle: "Participants",
  gameCharactersTitle: "Characters",
  gameMyCharactersTitle: "My characters",
  gameParticipantNameLabel: "Name:",
  gameParticipantCharacterLabel: "Character:",
  gameParticipantEmailLabel: "Email:",
  gameManageParticipant: "Manage this participant",
  gameDeleteCharacterTitle: "Delete character?",
  gameDeleteCharacterBody: "This action cannot be undone.",
  gameDeleteCharacterConfirm: "Delete",
  gameDeleteCharacterCancel: "Cancel",
  gameDeleteCharacterAria: "Delete character",
  gameManageCharacter: "Edit character",
  joinIntro: "To try Hexploit before everyone else, enter your email address.",
  joinEmailLabel: "Your email address",
  joinEmailDescription: "By creating your account, you will be able to find all your games and associated characters",
  joinEmailPlaceholder: "email@example.com",
  joinReadyBadge: "Ready to play",
  joinReadyDescription: "You will join this game and access character creation.",
  joinLogoAlt: "Hexploit logo",
  manageIntro: "Add and customize your team's characters.",
  manageCharacterLabel: (index: number) => `Character ${index}`,
  manageDeleteCharacterAria: "Delete this character",
  managePlayerNamePlaceholder: "Player's first name",
  manageCharacterNamePlaceholder: "Your character's name, be creative!",
  manageDescriptionLabel: "Description",
  manageDescriptionPlaceholder: "Describe this character",
  manageDictationAria: "Dictate the description",
  manageImageLabel: "Soulchemy photo",
  manageChangeImage: "Change image",
  manageChooseImage: "Choose an image",
  manageResetImage: "Reset",
  manageNoFileSelected: "No file selected",
  manageSoulLabel: "Soul",
  manageAppearanceLabel: "Appearance",
  managePersonalityLabel: "Personality",
  managePowersLabel: "Powers",
  manageWeaknessesLabel: "Weaknesses",
  manageAddCharacterHint: "Tap to create a new character",
  manageSubmitCharacters: "Create the Avatars",
  manageChooseCardLabel: "Choose a card",
  manageChooseCardTitle: (label: string) => `Choose a card · ${label}`,
  manageSearchCardPlaceholder: "Search for a card",
  manageClearSelection: "Clear selection",
  manageToastAccountCreatedTitle: "Account created",
  manageToastAccountCreatedBody: "Your account has been created. A validation email was sent.",
  manageToastAccountCreatedBodyShort: "Your account has just been created. A validation email was sent.",
  manageToastSavedTitle: "Changes saved",
  manageToastSavedBody: "Your characters have been saved.",
  manageToastAutosaveTitle: "Auto save",
  manageToastAutosaveBody: "Changes saved.",
  manageFeedbackTitle: "What did you think of the game? Your feedback is very important to us!",
  manageFeedbackCta: "Give feedback (2 min)",
  manageEmailReminderLine1:
    "Check your emails; you'll find a link to your Hexploit account to retrieve the game you just played.",
  manageEmailReminderLine2: "If you enjoyed the game, follow us on social media so you don't miss anything!",
  manageInstagramAria: "Hexploit Instagram",
  manageDiscordAria: "Hexploit Discord",
  manageYoutubeAria: "Hexploit Youtube",
  manageLogoAlt: "Hexploit",
  emptyValue: "—",
  resetPasswordTitle: "Hexploit - New password",
  resetPasswordHeading: "Reset password",
  resetPasswordPasswordLabel: "Password",
  resetPasswordPasswordPlaceholder: "Your password...",
  resetPasswordPasswordConfirmationLabel: "Confirm password",
  resetPasswordPasswordConfirmationPlaceholder: "Confirm your password...",
  resetPasswordCancel: "Cancel",
  resetPasswordSubmit: "Send",
  resetPasswordInvalidPassword: "Invalid password",
  resetPasswordInvalidConfirmation: "Invalid password confirmation",
  resetPasswordInvalidLink: "Invalid reset link",
  resetPasswordInvalidEmailOrCode: "Invalid email or code",
  signupTitle: "Hexploit - Create an account",
  signupHeading: "Create an account",
  signupEmailLabel: "Email",
  signupEmailPlaceholder: "email@address.com",
  signupPasswordLabel: "Password",
  signupPasswordPlaceholder: "Your password...",
  signupPasswordConfirmationPlaceholder: "Confirm your password",
  signupNewsletterLabel: "Subscribe to the newsletter to follow the game's progress",
  signupSubmit: "Create an account",
  signupHaveAccount: "Already have an account?",
  signupLoginLink: "Log in",
  signupSuccess: "Your account has been created. You'll receive a validation email. Check your SPAM folder.",
  signupPasswordMismatch: "Password confirmation does not match",
  signupGenericError: "Something went wrong. Please try again.",
  signupEmailExists: "An account already exists with this email",
  loginTitle: "Hexploit - Login",
  loginHeading: "Login",
  loginEmailLabel: "Email",
  loginEmailPlaceholder: "email@address.com",
  loginPasswordLabel: "Password",
  loginPasswordPlaceholder: "Your password...",
  loginForgotPassword: "Forgot password",
  loginSubmit: "Log in",
  loginNoAccount: "Don't have an account yet?",
  loginCreateAccountLink: "Create an account",
  loginInvalidCredentials: "Incorrect email or password",
  loginTooManyAttempts: "Too many attempts in a short time, please contact team@hexploit.fr",
  mailVerificationTitle: "Hexploit - Email verification",
  navSiteLink: "Hexploit.fr",
  navGames: "Games",
  navAccount: "My account",
  navLanguage: "Language",
  footerTagline: "Hexploit - what if creating stories became a game?",
  footerVideoRules: "Video rules",
  footerContact: "Contact us",
  footerInstagramAria: "Join us on Instagram",
  footerYoutubeAria: "Hexploit Youtube channel",
  footerFacebookAria: "Join us on Facebook",
};

export default globalStrings;
